"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parent = function (target) {
    /* tslint:disable-next-line:strict-boolean-expressions */
    return target.parentNode || undefined;
};
